import { TileNotClickable } from "../../StyledComponents";
import type { ISERPRecord } from "../../types";

import { SerpTileContent } from "./SerpTile";

export const StaticSerpTile = ({ serpFeature }: { serpFeature: ISERPRecord }) => {
    const serpName = serpFeature.serpFeature;

    if (!serpFeature) {
        return null;
    }

    return (
        <TileNotClickable>
            <SerpTileContent serpName={serpName} />
        </TileNotClickable>
    );
};
